import { Link } from 'react-router-dom'
import { Home, Phone } from 'lucide-react'
import { useApp } from '../context/app-context'
import { t } from '../i18n'
import SEO from '../components/SEO'

export default function NotFound() {
  const { lang } = useApp()
  const isAr = lang === 'ar'

  return (
    <main className="page" dir={isAr ? 'rtl' : 'ltr'}>
      <SEO title="404" description={isAr ? 'الصفحة غير موجودة' : 'Page not found'} />
      <div className="not-found">
        <div
          aria-hidden="true"
          style={{
            fontSize: 'clamp(64px, 14vw, 110px)',
            fontWeight: 900,
            lineHeight: 1,
            color: 'var(--border)',
            letterSpacing: '-0.05em',
            userSelect: 'none',
          }}
        >
          404
        </div>
        <h2 style={{ margin: 0 }}>{isAr ? 'هذه الصفحة غير موجودة' : 'This page does not exist'}</h2>
        <p style={{ color: 'var(--text-muted)', margin: 0 }}>
          {isAr
            ? 'ربما تغيّر الرابط أو أن الصفحة نُقلت.'
            : 'The link may have changed or the page was moved.'}
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/" className="btn btn-primary">
            <Home size={18} aria-hidden="true" />
            {t(lang, 'home')}
          </Link>
          <a href="tel:+201028137221" className="btn btn-outline" style={{ color: 'var(--primary)', borderColor: 'var(--primary)' }}>
            <Phone size={18} aria-hidden="true" />
            {t(lang, 'phone')}
          </a>
        </div>
      </div>
    </main>
  )
}
